//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import { PostDetailsPostType } from '@models/PostDetailsPostType';
import { MediaTrackingEventName } from '@tracker/mediaTracking/mediaTrackingModel';
import { SCHEDULER_POST_DETAILS_ROUTES } from 'app/initialization/routing/routingConstants';
import { UniversalPostType } from '@apis/universal-posts/universalPostsApiModel';

(function () {
  const uia = angular.module('uia');

  uia.directive('universalImageActionsScheduleNow', [
    '$window',
    '$q',
    'ErrorNotificationService',
    'UniversalImageActionsService',
    'SessionVarsService',
    'UniversalItemId',
    function (
      $window,
      $q,
      ErrorNotificationService,
      UniversalImageActionsService,
      SessionVarsService,
      UniversalItemId,
    ) {
      return {
        restrict: 'E',
        require: '^universalImageActionsModal',
        scope: {},
        template: require('@legacy-components/common/universal-image-actions/universal-image-actions-schedule-now.html'),
        link($scope) {
          const launchOptions =
            UniversalImageActionsService.getCurrentLaunchOptions();

          $scope.mediaTrackingEventName = MediaTrackingEventName;

          $scope.model = {
            loading: true,
            scheduleUrls: {
              instagramPost: null,
              instagramStory: null,
              instagramReels: null,
              facebook: null,
              pinterest: null,
              tiktokVideoAutomatic: null,
              twitter: null,
            },
            isVideo: null,
            isFacebookReview: SessionVarsService.isFacebookReview(),
            // TODO: PD-240739: Clean up UniversalScheduler feature flag once released
            isUniversalSchedulerEnabled: SessionVarsService.isFeatureEnabled(
              FeatureNames.UniversalScheduler,
            ),
            // TODO: PD-264381: Cleanup youtube_automatic_posting feature flag
            isYouTubeAutomaticSchedulingEnabled:
              SessionVarsService.isFeatureEnabled(
                FeatureNames.YoutubeAutomaticPosting,
              ),
          };

          function initialize() {
            UniversalImageActionsService.getItemMetadataAsync(
              launchOptions.getUniversalItemId(),
            )
              .then((itemMetadata) => {
                $scope.model.loading = false;

                // As per DEV-45618, we need to fetch the root cuid for items with legacy network universal ids
                let uid = launchOptions.getUniversalItemId();
                if (
                  itemMetadata.sourceNetwork &&
                  itemMetadata.networkIdentifier
                ) {
                  uid = new UniversalItemId(
                    itemMetadata.sourceNetwork.toLowerCase(),
                    itemMetadata.networkIdentifier,
                  );
                } else if (
                  itemMetadata.networkIdentifier &&
                  itemMetadata.networkIdentifier.indexOf('mis_') === 0
                ) {
                  uid = new UniversalItemId(
                    'media-import',
                    itemMetadata.networkIdentifier,
                  );
                }
                const cuid = `${uid.toString()}.${SessionVarsService.getClientId()}`;

                // Check if the item is a video because we only want to schedule videos to Instagram Reels
                $scope.model.isVideo = !!itemMetadata.videoSource;

                if ($scope.model.isUniversalSchedulerEnabled) {
                  const baseUrl = `${SCHEDULER_POST_DETAILS_ROUTES.SCHEDULER}?targetCuid=${cuid}`;
                  $scope.model.scheduleUrls.instagramPost = `${baseUrl}&postType=${UniversalPostType.InstagramFeedAutomaticPost}`;
                  $scope.model.scheduleUrls.instagramStory = `${baseUrl}&postType=${UniversalPostType.InstagramStoryGroupAutomaticPost}`;
                  $scope.model.scheduleUrls.instagramReels = `${baseUrl}&postType=${UniversalPostType.InstagramReelsAutomaticPost}`;
                  $scope.model.scheduleUrls.facebook = `${baseUrl}&postType=${UniversalPostType.FacebookPageFeedPost}`;
                  $scope.model.scheduleUrls.pinterest = `${baseUrl}&postType=${UniversalPostType.PinterestOrganicPin}`;
                  $scope.model.scheduleUrls.tiktokVideoAutomatic = `${baseUrl}&postType=${UniversalPostType.TikTokVideoAutomaticPost}`;
                  $scope.model.scheduleUrls.twitter = `${baseUrl}&postType=${UniversalPostType.TwitterMediaPost}`;
                  $scope.model.scheduleUrls.youtube = `${baseUrl}&postType=${UniversalPostType.YouTubeAutomaticPost}`;
                } else {
                  $scope.model.scheduleUrls.instagramPost = `${SCHEDULER_POST_DETAILS_ROUTES.INSTAGRAM}?postType=post&targetCuid=${cuid}`;
                  $scope.model.scheduleUrls.instagramStory = `${SCHEDULER_POST_DETAILS_ROUTES.INSTAGRAM}?postType=story&targetCuid=${cuid}`;
                  $scope.model.scheduleUrls.instagramReels = `${SCHEDULER_POST_DETAILS_ROUTES.INSTAGRAM}?postType=reels&targetCuid=${cuid}`;
                  $scope.model.scheduleUrls.facebook = `${SCHEDULER_POST_DETAILS_ROUTES.FACEBOOK}?targetCuid=${cuid}`;
                  $scope.model.scheduleUrls.pinterest = `${SCHEDULER_POST_DETAILS_ROUTES.PINTEREST}?targetCuids=${cuid}`;
                  $scope.model.scheduleUrls.tiktokVideoAutomatic = `${SCHEDULER_POST_DETAILS_ROUTES.TIKTOK}?postType=${PostDetailsPostType.TikTokVideoAutomatic}&targetCuid=${cuid}`;
                  $scope.model.scheduleUrls.twitter = `${SCHEDULER_POST_DETAILS_ROUTES.TWITTER}?targetCuid=${cuid}`;
                }
              })
              .catch(() => {
                // TODO: Add better error handling
                const error = 'We were unable to load the Schedule Now page.';
                $scope.$emit('uia:modal:close', {
                  result: { error },
                });
              });
          }

          $scope.trackEvent = (eventName) => {
            UniversalImageActionsService.trackMediaEvent(eventName);
          };

          initialize();
        },
      };
    },
  ]);
})();
